(function (window, document) {
  'use strict';

  var rates = window.__tyrotAutoDiscountRates || {};
  window.__tyrotAutoDiscountRates = rates;

  function collectRates(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var maps = root.querySelectorAll('[data-tyrot-auto-discount-map]:not([data-tyrot-auto-discount-map-ready])');

    Array.prototype.forEach.call(maps, function (mapElement) {
      try {
        var parsedRates = JSON.parse(mapElement.textContent || '{}');
        Object.keys(parsedRates).forEach(function (variantId) {
          rates[String(variantId)] = Number(parsedRates[variantId]) || 0;
        });
      } catch (error) {
        if (window.console && window.console.warn) {
          window.console.warn('TYROT discount preview map could not be read.', error);
        }
      }

      mapElement.setAttribute('data-tyrot-auto-discount-map-ready', 'true');
    });
  }

  function formatMoney(cents) {
    if (window.T4SThemeSP && window.T4SThemeSP.Currency && typeof window.T4SThemeSP.Currency.formatMoney === 'function') {
      return window.T4SThemeSP.Currency.formatMoney(cents);
    }

    var currency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active
      ? window.Shopify.currency.active
      : 'USD';

    return new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency',
      currency: currency
    }).format(cents / 100);
  }

  function pricePair(priceElement, originalMoney, saleMoney) {
    if (String(priceElement.getAttribute('data-formart-price')) === 'ins-del') {
      return '<ins>' + saleMoney + '</ins> <del>' + originalMoney + '</del>';
    }

    return '<del>' + originalMoney + '</del> <ins>' + saleMoney + '</ins>';
  }

  function badge(priceElement, percent, savedMoney) {
    var saleType = String(priceElement.getAttribute('data-saletype') || '');
    var template;

    if (saleType === '1') {
      template = priceElement.getAttribute('data-tyrot-save-percent-template') || 'Save [sale]%';
      return ' <span class="t4s-badge-price">' + template.replace('[sale]', String(percent)) + '</span>';
    }

    if (saleType === '2') {
      template = priceElement.getAttribute('data-tyrot-save-fixed-template') || 'Save [sale]';
      return ' <span class="t4s-badge-price">' + template.replace('[sale]', savedMoney) + '</span>';
    }

    return '';
  }

  function updatePrice(event) {
    var variant = event.currentVariant;
    if (!variant || !variant.id) return;

    var eventRoot = event.target && event.target.querySelectorAll ? event.target : document;
    collectRates(eventRoot);
    collectRates(document);

    var priceElement = eventRoot.querySelector('[data-product-price]');
    if (!priceElement) return;

    var price = Number(variant.price) || 0;
    var compareAtPrice = Number(variant.compare_at_price) || 0;
    var rate = Number(rates[String(variant.id)]) || 0;
    var hasNativeSale = compareAtPrice > price;
    var html;

    if (rate > 0 && !hasNativeSale) {
      var previewPrice = Math.round(price * (100 - rate) / 100);
      html = pricePair(priceElement, formatMoney(price), formatMoney(previewPrice));
      html += badge(priceElement, rate, formatMoney(price - previewPrice));
    } else if (hasNativeSale) {
      var nativePercent = Math.round(100 * (compareAtPrice - price) / compareAtPrice);
      html = pricePair(priceElement, formatMoney(compareAtPrice), formatMoney(price));
      html += badge(priceElement, nativePercent, formatMoney(compareAtPrice - price));
    } else {
      html = formatMoney(price);
    }

    priceElement.innerHTML = html;

    var stickyPrice = document.querySelector('[data-sticky-price]');
    if (stickyPrice) {
      stickyPrice.innerHTML = rate > 0 && !hasNativeSale
        ? pricePair(stickyPrice, formatMoney(price), formatMoney(Math.round(price * (100 - rate) / 100)))
        : hasNativeSale
          ? pricePair(stickyPrice, formatMoney(compareAtPrice), formatMoney(price))
          : formatMoney(price);
    }
  }

  function bind() {
    if (typeof window.jQuery_T4NT !== 'function') {
      window.setTimeout(bind, 50);
      return;
    }

    collectRates(document);
    window.jQuery_T4NT(document)
      .off('variant:changed.tyrotAutoDiscountPreview')
      .on('variant:changed.tyrotAutoDiscountPreview', updatePrice);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind, { once: true });
  } else {
    bind();
  }
})(window, document);

